export default [
	{
		title: 'Articles of Incorporation',
		href: '/documents/articles-of-incorporation',
		description: 'of Clearwater Farms Unit #1 Property Owners Association',
	},
	{
		title: 'By-Laws',
		href: '/documents/by-laws',
		description: 'of Clearwater Farms Property Owners Association',
	},
	{
		title: 'Rules and Regulations',
		href: '/documents/rules-and-regulations',
		description: '( Amended August 2026 )',
	},
	{
		title: 'CC&Rs',
		href: '/documents/cc-and-r-s-notarized',
		description: 'Declaration of Conditions, Covenants and Restrictions',
	},
	{
		title: 'Irrigation Info',
		href: '/documents/irrigation-information',
		description: 'Basic Irrigation Information',
	},
	{
		title: 'How to Change Gates',
		href: '/documents/how-to-change-gates',
		description: 'How to change ditch gates to get your water',
	},
	// {
	// 	title: 'Policies & Procedures',
	// 	href: '/documents/policies-and-procedures',
	// 	description: 'Document dated 8/1/2024',
	// },
	{
		title: 'Construction Architectural Review',
		href: '/documents/architectural-review-form-final',
		description: 'How to get Architectural approval before you build',
	},
	{
		title: 'Culvert & Irrigation Architectural Review',
		href: '/documents/culvert-and-irrigation-architectural-review',
		description: 'How to get approval for Culverts and Irrigation',
	},
	{
		title: 'Violation and Fine Policy',
		href: '/documents/violation-and-fine-policy',
		description: 'Document dated 10/2024',
	},
	{
		title: 'Messaging Consent Policy',
		href: '/documents/messaging-consent-policy',
		description: 'for CFPOA Communications and Notifications',
	},
]
